<template>
    <div>
        <b-modal id="modal-validasi-p3b" v-model="showModal" centered size="xl" hide-footer ok-only ok-title="Ok"
            title="Detail Hasil Sensus BMD" @hidden="onModalClose" @ok="onModalConfirm">
            <div>
                <div class="card mb-1 shadow-sm border border-1 ">
                    <div class="card-header border-bottom mb-1">
                        <div class="card-title">
                            <span class="text-primary text-uppercase">
                                {{ (formDatas.asal_input == 'web') ? 'Pendalaman Register' : 'Pendataan' }}
                            </span>
                        </div>
                        <div class="card-toolbar">
                            <div class="d-flex flex-row" style="gap: 2px">
                                <div>
                                    <b-badge :variant="badgeStatus(formDatas.status_hasil_sensus)">
                                        <span class="text-capitalize">{{
                                            formDatas.status_hasil_sensus_nama
                                        }}</span>
                                    </b-badge>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="card-body overflow-auto">
                        <div>
                            <div class="text-nowrap mb-25 d-flex justify-content-start">
                                <span class="align-text-top font-small-5">
                                    PD/UKPD/UPB : {{ formDatas.kolok + ' - ' + formDatas.nalok }}</span>
                            </div>
                            <div class="text-nowrap mb-25 d-flex justify-content-start">
                                <span class="align-text-top font-small-5">
                                    Kode QR Ruang : {{ formDatas.qr_ruang }}</span>
                            </div>
                            <div class="text-nowrap mb-50">
                                <div v-if="formDatas.asal_input == 'mobile'" class="align-text-top font-small-5">
                                    <div>
                                        Kode QR BMD : {{ formDatas.kode_qr }}
                                    </div>
                                </div>
                            </div>
                            <div class="text-nowrap mb-50">
                                <div class="d-flex justify-content-between" style="gap: 5px">
                                    <div>
                                        <div class="d-flex" style="gap:2px">
                                            <b-badge variant="light-info">
                                                <span class="text-capitalize">{{
                                                    formDatas.kategori
                                                }}</span>
                                            </b-badge>
                                            <b-badge variant="light-success">
                                                <span class="text-capitalize">{{
                                                    formDatas.keberadaan || formDatas.jenis_pendalaman
                                                }}</span>
                                            </b-badge>
                                            <b-badge v-if="formDatas.ganda == 'iya'"
                                                style="background-color:rgba(242, 40, 40, 0.69);color: white;">
                                                Ganda
                                            </b-badge>
                                            <b-badge style="background-color: rgb(40 97 242 / 69%);color: white;">
                                                <feather-icon v-if="formDatas.asal_input == 'web'" icon="MonitorIcon"
                                                    class="mr-25" />
                                                <feather-icon v-else icon="SmartphoneIcon" class="mr-25" />
                                                <span class="text-capitalize">{{
                                                    formDatas.asal_input
                                                }}</span>
                                            </b-badge>
                                        </div>
                                    </div>
                                    <div class="d-flex flex-column text-nowrap">
                                        <div>
                                            <small>Dibuat : {{ parserValue('dateTime', formDatas.created_at)
                                            }}</small>
                                        </div>
                                        <div>
                                            <small>Last Update : {{ parserValue('dateTime', formDatas.updated_at)
                                            }}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <b-overlay :show="isLoadGetData" variant="light" opacity="0.85" blur="2px" rounded="sm">
                    <div class="row">
                        <div class="col-12" :class="(formDatas.ganda === 'iya') ? 'col-xl-6' : ''">
                            <div class="card shadow-sm border border-1 h-100">
                                <template v-if="formDatas.kategori == 'tercatat'">
                                    <div class="card-header border-bottom mb-1">
                                        <div class="card-title">
                                            <span class="text-primary text-uppercase">Data BMD</span>
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <div class="row mb-1">
                                            <div class="col-12">
                                                <div class="font-weight-bold text-muted">Guid Aset</div>
                                            </div>
                                            <div class="col-12 col-md-8">
                                                <div>
                                                    {{ formDatas.guid_aset || '-' }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-1">
                                            <div class="col-12">
                                                <div class="font-weight-bold text-muted">Nomor Register</div>
                                            </div>
                                            <div class="col-12 col-md-8">
                                                <div>
                                                    {{ formDatas.noreg_108 || '-' }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-1">
                                            <div class="col-12">
                                                <div class="font-weight-bold text-muted">Kode Barang</div>
                                            </div>
                                            <div class="col-12 col-md-8">
                                                <div>
                                                    {{ formDatas.kobar_108 || '-' }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-1">
                                            <div class="col-12">
                                                <div class="font-weight-bold text-muted">Nama Barang</div>
                                            </div>
                                            <div class="col-12 col-md-8">
                                                <div>
                                                    {{ formDatas.nabar_108 || '-' }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-1">
                                            <div class="col-12">
                                                <div class="font-weight-bold text-muted">Tanggal Perolehan</div>
                                            </div>
                                            <div class="col-12 col-md-8">
                                                <div>
                                                    <span>{{ parserValue('dateOnly', formDatas.tgl_oleh) || '-' }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-1">
                                            <div class="col-12">
                                                <div class="font-weight-bold text-muted">Total Harga</div>
                                            </div>
                                            <div class="col-12 col-md-8">
                                                <div>
                                                    {{ `${new Intl.NumberFormat('id-ID', {
                                                        maximumFractionDigits: 2,
                                                    }).format(formDatas.total_harga)}` }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-1">
                                            <div class="col-12">
                                                <div class="font-weight-bold text-muted">Bahan</div>
                                            </div>
                                            <div class="col-12 col-md-8">
                                                <div>
                                                    {{ formDatas.nama_bahan || '-' }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-1">
                                            <div class="col-12">
                                                <div class="font-weight-bold text-muted">Merk</div>
                                            </div>
                                            <div class="col-12 col-md-8">
                                                <div>
                                                    {{ formDatas.merk || '-' }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-1">
                                            <div class="col-12">
                                                <div class="font-weight-bold text-muted">Tipe</div>
                                            </div>
                                            <div class="col-12 col-md-8">
                                                <div>
                                                    {{ formDatas.tipe || '-' }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-1">
                                            <div class="col-12">
                                                <div class="font-weight-bold text-muted">Nomor Chasis</div>
                                            </div>
                                            <div class="col-12 col-md-8">
                                                <div>
                                                    {{ formDatas.nochasis || '-' }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-1">
                                            <div class="col-12">
                                                <div class="font-weight-bold text-muted">Nomor Mesin</div>
                                            </div>
                                            <div class="col-12 col-md-8">
                                                <div>
                                                    {{ formDatas.nomesin || '-' }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-1">
                                            <div class="col-12">
                                                <div class="font-weight-bold text-muted">Nomor Polisi</div>
                                            </div>
                                            <div class="col-12 col-md-8">
                                                <div>
                                                    {{ formDatas.nopol || '-' }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-1">
                                            <div class="col-12">
                                                <div class="font-weight-bold text-muted">Nomor BPKB</div>
                                            </div>
                                            <div class="col-12 col-md-8">
                                                <div>
                                                    {{ formDatas.nobpkb || '-' }}
                                                </div>
                                            </div>
                                        </div>
                                        <hr class="border border-1 border-light-primary" />
                                        <div class="row mb-1">
                                            <div class="col-12">
                                                <div class="card-title mb-0">
                                                    <span class="text-primary text-uppercase">Hasil Sensus</span>
                                                </div>
                                            </div>
                                        </div>
                                        <template v-if="formDatas.asal_input == 'web'">
                                            <template v-if="formDataHs.jenis_pendalaman == 'biaya-biaya'">
                                                <FormBiayaReadonly :fD="formDataHs.biaya_biaya" />
                                            </template>
                                            <template v-else-if="formDataHs.jenis_pendalaman == 'fisik-tidak-ditemukan'">
                                                <FormFisikNotFoundReadonly :fD="formDataHs.fisik_tidak_ditemukan" />
                                            </template>
                                        </template>
                                        <template v-else-if="formDatas.asal_input == 'mobile'">
                                            <template v-if="formDatas.kategori == 'tercatat'">
                                                <FormMobileTercatatReadonly :fD="formDataHs.mobile" />
                                            </template>
                                            <template v-else-if="formDatas.kategori == 'belum-tercatat'">
                                                <FormMobileTidakTercatatReadonly :fD="formDataHs.mobile" />
                                            </template>
                                        </template>
                                    </div>
                                </template>
                                <template v-else-if="formDatas.kategori == 'belum-tercatat'">
                                    <div class="card-header border-bottom mb-1">
                                        <div class="card-title">
                                            <span class="text-primary text-uppercase">Hasil Sensus</span>
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <FormMobileTidakTercatatReadonly :fD="formDataHs.mobile" />
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div v-if="formDatas.ganda === 'iya'" class="col-12 col-xl-6">
                            <div class="card shadow-sm border border-1 h-100">
                                <div class="card-header border-bottom mb-1">
                                    <div class="card-title">
                                        <span class="text-primary text-uppercase">Indikasi BMD Ganda</span>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-1">
                                        <div class="col-12">
                                            <div class="font-weight-bold text-muted">Guid Aset</div>
                                        </div>
                                        <div class="col-12 col-md-8">
                                            <div>
                                                {{ formDataHs.mobile.ganda_parent_guid_aset || '-' }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-1">
                                        <div class="col-12">
                                            <div class="font-weight-bold text-muted">Nomor Register</div>
                                        </div>
                                        <div class="col-12 col-md-8">
                                            <div>
                                                {{ formDataHs.mobile.ganda_parent_noreg_108 || '-' }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-1">
                                        <div class="col-12">
                                            <div class="font-weight-bold text-muted">Kode Barang</div>
                                        </div>
                                        <div class="col-12 col-md-8">
                                            <div>
                                                {{ formDataHs.mobile.ganda_parent_kobar_108 || '-' }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-1">
                                        <div class="col-12">
                                            <div class="font-weight-bold text-muted">Nama Barang</div>
                                        </div>
                                        <div class="col-12 col-md-8">
                                            <div>
                                                {{ formDataHs.mobile.ganda_parent_nabar_108 || '-' }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-1">
                                        <div class="col-12">
                                            <div class="font-weight-bold text-muted">Tanggal Perolehan</div>
                                        </div>
                                        <div class="col-12 col-md-8">
                                            <div>
                                                <span>{{ parserValue('dateOnly', formDataHs.mobile.ganda_parent_tgl_oleh) ||
                                                    '-'
                                                }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-1">
                                        <div class="col-12">
                                            <div class="font-weight-bold text-muted">Total Harga</div>
                                        </div>
                                        <div class="col-12 col-md-8">
                                            <div>
                                                {{ `${new Intl.NumberFormat('id-ID', {
                                                    maximumFractionDigits: 2,
                                                }).format(formDataHs.mobile.ganda_parent_total_harga)}` }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-1">
                                        <div class="col-12">
                                            <div class="font-weight-bold text-muted">Bahan</div>
                                        </div>
                                        <div class="col-12 col-md-8">
                                            <div>
                                                {{ formDataHs.mobile.ganda_parent_nama_bahan || '-' }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-1">
                                        <div class="col-12">
                                            <div class="font-weight-bold text-muted">Merk</div>
                                        </div>
                                        <div class="col-12 col-md-8">
                                            <div>
                                                {{ formDataHs.mobile.ganda_parent_merk || '-' }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-1">
                                        <div class="col-12">
                                            <div class="font-weight-bold text-muted">Tipe</div>
                                        </div>
                                        <div class="col-12 col-md-8">
                                            <div>
                                                {{ formDataHs.mobile.ganda_parent_tipe || '-' }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-1">
                                        <div class="col-12">
                                            <div class="font-weight-bold text-muted">Nomor Chasis</div>
                                        </div>
                                        <div class="col-12 col-md-8">
                                            <div>
                                                {{ formDataHs.mobile.ganda_parent_nochasis || '-' }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-1">
                                        <div class="col-12">
                                            <div class="font-weight-bold text-muted">Nomor Mesin</div>
                                        </div>
                                        <div class="col-12 col-md-8">
                                            <div>
                                                {{ formDataHs.mobile.ganda_parent_nomesin || '-' }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-1">
                                        <div class="col-12">
                                            <div class="font-weight-bold text-muted">Nomor Polisi</div>
                                        </div>
                                        <div class="col-12 col-md-8">
                                            <div>
                                                {{ formDataHs.mobile.ganda_parent_nopol || '-' }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-1">
                                        <div class="col-12">
                                            <div class="font-weight-bold text-muted">Nomor BPKB</div>
                                        </div>
                                        <div class="col-12 col-md-8">
                                            <div>
                                                {{ formDataHs.mobile.ganda_parent_nobpkb || '-' }}
                                            </div>
                                        </div>
                                    </div>
                                    <hr class="border border-1 border-light-primary" />
                                    <div class="row mb-1">
                                        <div class="col-12">
                                            <div class="card-title mb-0">
                                                <span class="text-primary text-uppercase">Hasil Sensus</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-1">
                                        <div class="col-12">
                                            <div class="font-weight-bold text-muted">Pada PD/UKPD/UPB</div>
                                        </div>
                                        <div class="col-12">
                                            <div>
                                                {{ (formDataHs.mobile.ganda_parent_kolok || '') + '-' +
                                                    (formDataHs.mobile.ganda_parent_nalok || '') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-1">
                                        <div class="col-12">
                                            <div class="font-weight-bold text-muted">Foto Barang</div>
                                        </div>
                                        <div class="col-12">
                                            <div>
                                                <ImageView
                                                    :imgUrl="formDataHs.mobile.ganda_parent_file_foto_barang || ''" />
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div class="row mb-2">
                                        <span class="col-12 font-weight-bold font-small-5 text-muted">Pendataan dilakukan
                                            pada</span>
                                        <div class="col-12 mt-50 overflow-auto rounded">
                                            <template v-if="formDataHs.mobile.ganda_parent_keberadaan == 'luar'">
                                                <template v-if="formDataHs.mobile.ganda_parent_detail_lokasi">
                                                    <div>
                                                        <span class="font-weight-bold font-small-5 text-muted">Lokasi
                                                            ID</span>
                                                        <div class="border border-1 rounded p-75 bg-light mb-1">
                                                            <span>{{ formDataHs.mobile.ganda_parent_detail_lokasi.id || '-'
                                                            }}</span>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <span class="font-weight-bold font-small-5 text-muted">Jalan /
                                                            Nomor</span>
                                                        <div class="border border-1 rounded p-75 bg-light mb-1">
                                                            <span>{{ formDataHs.mobile.ganda_parent_detail_lokasi.alamat ||
                                                                '-'
                                                            }} / {{
    formDataHs.mobile.ganda_parent_detail_lokasi.no_jalan ||
    '-' }}</span>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <span class="font-weight-bold font-small-5 text-muted">RT /
                                                            RW</span>
                                                        <div class="border border-1 rounded p-75 bg-light mb-1">
                                                            <span>{{ formDataHs.mobile.ganda_parent_detail_lokasi.rt || '-'
                                                            }} /
                                                                {{
                                                                    formDataHs.mobile.ganda_parent_detail_lokasi.rw || '-'
                                                                }}</span>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <span
                                                            class="font-weight-bold font-small-5 text-muted">Kelurahan</span>
                                                        <div class="border border-1 rounded p-75 bg-light mb-1">
                                                            <span>{{ formDataHs.mobile.ganda_parent_detail_lokasi.nm_kel ||
                                                                '-'
                                                            }}</span>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <span
                                                            class="font-weight-bold font-small-5 text-muted">Kecamatan</span>
                                                        <div class="border border-1 rounded p-75 bg-light mb-1">
                                                            <span>{{ formDataHs.mobile.ganda_parent_detail_lokasi.nm_kec ||
                                                                '-'
                                                            }}</span>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <span class="font-weight-bold font-small-5 text-muted">Kota /
                                                            Kabupaten</span>
                                                        <div class="border border-1 rounded p-75 bg-light mb-1">
                                                            <span>{{ formDataHs.mobile.ganda_parent_detail_lokasi.nm_rayon
                                                                ||
                                                                '-'
                                                            }}</span>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <span class="font-weight-bold font-small-5 text-muted">Kode
                                                            Pos</span>
                                                        <div class="border border-1 rounded p-75 bg-light mb-1">
                                                            <span>{{ formDataHs.mobile.ganda_parent_detail_lokasi.kodepos ||
                                                                '-'
                                                            }}</span>
                                                        </div>
                                                    </div>
                                                </template>
                                            </template>
                                            <template v-else-if="formDataHs.mobile.ganda_parent_keberadaan == 'dalam'">
                                                <template v-if="formDataHs.mobile.ganda_parent_detail_ruangan">
                                                    <div>
                                                        <span class="font-weight-bold font-small-5 text-muted">Ruangan
                                                            ID</span>
                                                        <div class="border border-1 rounded p-75 bg-light mb-1">
                                                            <span>{{ formDataHs.mobile.ganda_parent_detail_ruangan.id || '-'
                                                            }}</span>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <span class="font-weight-bold font-small-5 text-muted">Gedung</span>
                                                        <div class="border border-1 rounded p-75 bg-light mb-1">
                                                            <span>{{
                                                                `${(formDataHs.mobile.ganda_parent_detail_ruangan.kolok_gedung)
                                                                    ?
                                                                    formDataHs.mobile.ganda_parent_detail_ruangan.kolok_gedung :
                                                                    ''}${(formDataHs.mobile.ganda_parent_detail_ruangan.nalok_gedung)
                                                                        ?
                                                                        '::' +
                                                                        formDataHs.mobile.ganda_parent_detail_ruangan.nalok_gedung :
                                                                        ''}${(formDataHs.mobile.ganda_parent_detail_ruangan.noreg_gedung)
                                                                            ?
                                                                            '::' +
                                                                            formDataHs.mobile.ganda_parent_detail_ruangan.noreg_gedung :
                                                                            ''}${(formDataHs.mobile.ganda_parent_detail_ruangan.alamat_gedung)
                                                                                ?
                                                                                '::' +
                                                                                formDataHs.mobile.ganda_parent_detail_ruangan.alamat_gedung
                                                                                :
                                                                                ''} `
                                                                || '-' }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <span class="font-weight-bold font-small-5 text-muted">Lantai</span>
                                                        <div class="border border-1 rounded p-75 bg-light mb-1">
                                                            <span>{{ formDataHs.mobile.ganda_parent_detail_ruangan.lantai ||
                                                                '-'
                                                            }}</span>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <span class="font-weight-bold font-small-5 text-muted">Jenis
                                                            Ruangan</span>
                                                        <div class="border border-1 rounded p-75 bg-light mb-1">
                                                            <span>{{
                                                                formDataHs.mobile.ganda_parent_detail_ruangan.jenis_ruangan_nama
                                                                ||
                                                                '-' }}</span>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <span class="font-weight-bold font-small-5 text-muted">Nama
                                                            Ruangan</span>
                                                        <div class="border border-1 rounded p-75 bg-light mb-1">
                                                            <span>{{
                                                                formDataHs.mobile.ganda_parent_detail_ruangan.nama_ruangan
                                                                ||
                                                                '-' }}</span>
                                                        </div>
                                                    </div>
                                                </template>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-overlay>

                <hr />
                <!--  dikirim | dikembalikan-p3b | disetujui-p3b  -->
                <div v-if="!isFinal">
                    <template
                        v-if="closeSistemInformation.isOpen && formDataHs.hasil_sensus_bmd_id != null && ['dikirim', 'dikembalikan-p3b'].includes(formDatas.status_hasil_sensus) && $can('Validasi-P3B', 'b-hasil-sensus')">
                        <div class="card knowledge-base-bg text-center bg-light-primary" style="box-shadow: none;">
                            <div class="card-body ">
                                <h5 class="text-primary text-uppercase">
                                    Validasi P3B
                                </h5>
                                <b-card-text class="mb-2">
                                    <span class="font-weight-normal text-dark">
                                        P3B melakukan validasi terhadap data inventarisasi BMD yang diajukan PB
                                    </span>
                                </b-card-text>
                                <div class="d-flex justify-content-center" style="gap: 5px">
                                    <b-button variant="primary" class="mt-25 mt-md-0" @click="openp3bValidasiDialog">
                                        <feather-icon icon="CheckCircleIcon" size="15" class="mr-25" />
                                        <span class="font-weight-bold">Validasi</span>
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div v-if="!isFinal">
                    <template
                        v-if="closeSistemInformation.isOpen && formDataHs.hasil_sensus_bmd_id != null && ['disetujui'].includes(formDatas.status_hasil_sensus) && $can('Pengembalian-PUA', 'b-hasil-sensus') && cookiesRolesB == 'pua-admin'">
                        <div class="card text-center bg-light-danger" style="box-shadow: none;">
                            <div class="card-body ">
                                <h5 class="text-danger text-uppercase">
                                    Pengembalian PUA
                                </h5>
                                <b-card-text class="mb-2">
                                    <span class="font-weight-normal text-dark">
                                        PUA melakukan pengembalian hasil sensus kepada PB untuk melakukan sensus ulang
                                    </span>
                                </b-card-text>
                                <div class="d-flex justify-content-center" style="gap: 5px">
                                    <b-button variant="danger" class="mt-25 mt-md-0" @click="openPengemalianPuaDialog">
                                        <feather-icon icon="CheckCircleIcon" size="15" class="mr-25" />
                                        <span class="font-weight-bold">Kembalikan</span>
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <template v-if="formDataHs.hasil_sensus_bmd_id != null">
                    <div v-for="(item, i) in formDataHs.workflow" :key="i" class="card mb-1">
                        <div class="card-header border-bottom">
                            <h4 class="font-weight-bold text-uppercase">
                                Validasi P3B
                            </h4>
                        </div>
                        <div class="card-body pt-1">
                            <div class="row">
                                <div class="col-12 col-md-4 col-lg-4">
                                    <div>
                                        <span class="font-weight-bolder">Divalidasi Oleh</span>
                                    </div>
                                    <div>
                                        <span>{{ item.action_by || '-' }}</span>
                                    </div>
                                </div>
                                <div class="col-12 col-md-4 col-lg-4">
                                    <div>
                                        <span class="font-weight-bolder">Divalidasi Pada</span>
                                    </div>
                                    <div>
                                        <span>{{ parserValue('dateTime', item.action_at) || '-' }}</span>
                                    </div>
                                </div>
                                <div class="col-12 col-md-4 col-lg-4">
                                    <div>
                                        <span class="font-weight-bolder">Status Validasi</span>
                                    </div>
                                    <span class="badge" :class="badgeActionWf(item.action)">{{
                                        item.action || '-'
                                    }}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div>
                                        <span class="font-weight-bolder">Catatan Validasi</span>
                                    </div>
                                    <div>
                                        <span>
                                            {{ item.catatan || '-' }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <!-- Delete Button jika : formDatas.kategori == 'belum-tercatat' && formDatas.status_hasil_sensus == 'dikembalikan' -->
                <div v-if="!isFinal">
                    <div
                        v-if="closeSistemInformation.isOpen && formDatas.kategori == 'belum-tercatat' && formDatas.status_hasil_sensus == 'dikembalikan'">
                        <div class="card bg-light-warning">
                            <div class="card-body">
                                <div class="mb-1">
                                    Apabila melakukan penghapusan data <b>BMD belum tercatat</b>, maka data tersebut akan
                                    dihapus
                                    secara permanen. Data "BMD belum tercatat" yang dapat dihapus hanya untuk status
                                    <b>dikembalikan</b>. Dan qr code yg tertaut bisa digunakan kembali
                                </div>
                                <div>
                                    <b-button v-if="!loadingBtnHapusData" variant="danger" @click="openHapusDataDialog">
                                        <span class="align-middle">Hapus Data</span>
                                    </b-button>
                                    <b-button v-else variant="danger" disabled>
                                        <b-spinner small />
                                        Loading...
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
        <b-modal centered id="modal-p3b-validasi" ref="p3bValidasiModalRef" scrollable title="Validasi P3B"
            :no-close-on-backdrop="true" cancel-title="Batal" ok-title="Kirim" cancel-variant="outline-secondary"
            @ok="confirmP3bValidasiDialog">
            <validation-observer ref="rulesValP3B">
                <b-row>
                    <b-col cols="12">
                        <div>
                            <span>Status Persetujuan <span class="text-danger">*</span></span>
                        </div>
                        <validation-provider #default="{ errors }" name="Status Persetujuan" rules="required">
                            <div class="d-flex flex-wrap flex-row" style="gap:20px;margin-top: 5px;">
                                <b-form-radio v-model="formDatasP3BValidasi.is_validasi" name="setuju" value="setuju">
                                    Setuju
                                </b-form-radio>
                                <b-form-radio v-model="formDatasP3BValidasi.is_validasi" name="dikembalikan"
                                    value="kembalikan">
                                    Dikembalikan
                                </b-form-radio>
                            </div>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-col>
                    <b-col v-if="formDatasP3BValidasi.is_validasi == 'kembalikan'" cols="12" class="mt-2">
                        <div>
                            <span class="required">Catatan Validasi <span class="text-danger">*</span></span>
                        </div>
                        <validation-provider #default="{ errors }" name="Catatan Validasi" rules="required">
                            <b-form-textarea id="catatan-p3b" v-model="formDatasP3BValidasi.catatan"
                                placeholder="Isi Catatan Validasi" rows="3" :state="errors.length > 0 ? false : null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-col>
                </b-row>
            </validation-observer>
            <template slot="modal-footer">
                <!-- You can add your custom footer content here -->
                <b-button v-if="!loadingBtnConfirm" variant="primary" @click="confirmP3bValidasiDialog">
                    <span class="align-middle">Kirim</span>
                </b-button>
                <b-button v-else variant="primary" disabled>
                    <b-spinner small />
                    Loading...
                </b-button>
            </template>
        </b-modal>
        <b-modal centered id="modal-pengembalian-pua" ref="pengembalianPuaModalRef" title="Konfirmasi Pengembalian"
            button-size="sm" ok-title="Kirim" cancel-title="Batal" cancel-variant="outline-secondary"
            @ok="confirmPengembalianPua">
            <validation-observer ref="rulesPengembalianPua">
                <div class="row">
                    <div class="col-12">
                        <div>
                            <span class="required">Catatan Pengembalian <span class="text-danger">*</span></span>
                        </div>
                        <validation-provider #default="{ errors }" name="Catatan Pengembalian" rules="required">
                            <b-form-textarea id="catatan-p3b" v-model="formDatasPengembalianPua.catatan"
                                placeholder="Isi Catatan Pengembalian" rows="3" :state="errors.length > 0 ? false : null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </div>
                </div>
            </validation-observer>
            <template slot="modal-footer">
                <!-- You can add your custom footer content here -->
                <b-button v-if="!loadingBtnPengembalianPua" variant="primary" @click="confirmPengembalianPua">
                    <span class="align-middle">Kirim</span>
                </b-button>
                <b-button v-else variant="primary" disabled>
                    <b-spinner small />
                    Loading...
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-hapus" ref="hapusDataRef" centered title="Hapus Data Pendataan dan Pendalaman" button-size="md"
            ok-title="Ya" cancel-title="Tidak" ok-variant="danger" cancel-variant="outline-secondary"
            @ok="confirmHapusData">
            <b-card-text>
                Data akan dihapus secara permanen. Lanjutkan ?
            </b-card-text>
        </b-modal>
    </div>
</template>
  
<script>
import { ref, onMounted, watchEffect, nextTick } from '@vue/composition-api'
import vSelect from "vue-select";
import { id as localeId } from "vee-validate/dist/locale/id";
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import Cleave from 'vue-cleave-component'
import { parserValue } from '@/libs/helper'
import { VBTooltip, BButton } from 'bootstrap-vue'
import hasilSensus from "@/composables/b/hasilSensus";
import { showNotifikasi } from '@/libs/helper';
import FormBiayaReadonly from './FormBiayaReadonly.vue'
import FormFisikNotFoundReadonly from './FormFisikNotFoundReadonly.vue'
import FormMobileTercatatReadonly from './FormMobileTercatatReadonly.vue'
import FormMobileTidakTercatatReadonly from './FormMobileTidakTercatatReadonly.vue'
import ImageView from '@/components/base/ImageView'
import { closeSistemKibB } from '@/libs/helper';

export default {
    props: {
        show: { Boolean, required: true },
        dataModal: {
            type: Object,
            default: () => ({}),
        },
    },
    setup(props, context) {
        localize('id', localeId);
        const g = context.root;
        const cookiesRolesB = ref(g.$cookies.get("roles_b"));
        const showModal = ref(false);
        const formDatas = ref({});
        const formDataHs = ref({})
        const isFinal = ref(false);
        const isLoadGetData = ref(false);
        const getData = () => {
            isLoadGetData.value = true;
            formDataHs.value = {
                biaya_biaya: {},
                fisik_tidak_ditemukan: {},
                mobile: {
                    ganda_parent_detail_lokasi: {},
                    ganda_parent_detail_ruangan: {},
                }
            };
            let params = {
                filter_platform: props.dataModal.asal_input,
                filter_kategori: props.dataModal.kategori,
                hasil_sensus_bmd_id: props.dataModal.id,
            };
            hasilSensus.getDetailDataBmdHasilSensus(g, params).then(res => {
                if (res.data) {
                    formDataHs.value = res.data
                }
                isFinal.value = Boolean(Number(res.is_final));
                isLoadGetData.value = false;
            }).catch(err => {
                isLoadGetData.value = false;
                console.log(err)
            });
        };

        watchEffect(() => {
            showModal.value = props.show;
            formDatas.value = props.dataModal
            if (props.show) {
                getData();
            }
        });

        const formDatasP3BValidasi = ref({
            username: g.$cookies.get("username"),
            is_validasi: null,
            catatan: null
        });
        const p3bValidasiModalRef = ref(null);
        const openp3bValidasiDialog = () => {
            p3bValidasiModalRef.value.show();
        };
        const loadingBtnConfirm = ref(false);
        const confirmP3bValidasiDialog = (bvModalEvt) => {
            let fd = { ...formDatasP3BValidasi.value };
            fd.hasil_sensus_bmd_id = formDataHs.value.hasil_sensus_bmd_id;
            fd.asal_input = formDataHs.value.asal_input;
            fd.kolok = formDataHs.value.kolok;
            fd.kategori = props.dataModal.kategori;
            bvModalEvt.preventDefault();
            context.refs.rulesValP3B.validate().then(success => {
                if (success) {
                    loadingBtnConfirm.value = true;
                    hasilSensus.validasiP3b(g, fd).then(resp => {
                        if (resp.success && resp.code == '200') {
                            showNotifikasi(g, 'success', 'Success', resp.message)
                            nextTick();
                            context.refs.p3bValidasiModalRef.toggle('#toggle-btn');
                            context.emit('confirmDialog')
                            loadingBtnConfirm.value = false;
                            formDatasP3BValidasi.value = {
                                username: g.$cookies.get("username"),
                                is_validasi: null,
                                catatan: null
                            }
                        } else {
                            loadingBtnConfirm.value = false;
                            showNotifikasi(g, 'danger', 'Error', resp.message)
                        }
                    }).catch(err => {
                        loadingBtnConfirm.value = false;
                        console.log(err)
                    });
                }
            });
        };

        ///
        const formDatasPengembalianPua = ref({
            username: g.$cookies.get("username"),
            catatan: null
        });
        const pengembalianPuaModalRef = ref(null);
        const openPengemalianPuaDialog = () => {
            pengembalianPuaModalRef.value.show();
        };
        const loadingBtnPengembalianPua = ref(false);
        const confirmPengembalianPua = (bvModalEvt) => {
            let fd = { ...formDatasPengembalianPua.value };
            fd.hasil_sensus_bmd_id = formDataHs.value.hasil_sensus_bmd_id;
            fd.asal_input = formDataHs.value.asal_input;
            fd.kolok = ((formDataHs.value.data_register) ? formDataHs.value.data_register.kolok_upb : null) || formDataHs.value.kolok;
            fd.kategori = props.dataModal.kategori;
            bvModalEvt.preventDefault();
            context.refs.rulesPengembalianPua.validate().then(success => {
                if (success) {
                    loadingBtnPengembalianPua.value = true;
                    hasilSensus.pengembalianPua(g, fd).then(resp => {
                        if (resp.success && resp.code == '200') {
                            showNotifikasi(g, 'success', 'Success', resp.message)
                            nextTick();
                            context.refs.pengembalianPuaModalRef.toggle('#toggle-btn');
                            context.emit('confirmDialog')
                            loadingBtnPengembalianPua.value = false;
                            formDatasPengembalianPua.value = {
                                username: g.$cookies.get("username"),
                                catatan: null
                            }
                        } else {
                            loadingBtnPengembalianPua.value = false;
                            showNotifikasi(g, 'danger', 'Error', resp.message)
                        }
                    }).catch(err => {
                        loadingBtnConfirm.value = false;
                        console.log(err)
                    });
                }
            });
        };

        /* Hapus Data */
        const loadingBtnHapusData = ref(false)
        const formDataHapusData = ref({
            username: g.$cookies.get('username'),
        })
        const hapusDataRef = ref(null)
        const openHapusDataDialog = () => {
            hapusDataRef.value.show()
        }
        const confirmHapusData = () => {
            loadingBtnHapusData.value = true
            const fd = { ...formDataHapusData.value }
            fd.hasil_sensus_bmd_id = formDataHs.value.hasil_sensus_bmd_id;
            hasilSensus.submitHapusData(g, fd).then(resp => {
                if (resp.success) {
                    context.emit('confirmDialog')
                    showNotifikasi(g, 'success', 'Success', resp.message);
                    formDataHapusData.value = {
                        username: g.$cookies.get("username"),
                        catatan: null
                    }
                } else {
                    showNotifikasi(g, 'danger', 'Error', resp.message)
                }
                loadingBtnHapusData.value = false
            }).catch(err => {
                console.log(err)
                loadingBtnHapusData.value = false
            })
        }

        const closeSistemInformation = ref({});
        setInterval(() => {
            closeSistemInformation.value = closeSistemKibB();
        }, 1000);
        return {
            cookiesRolesB,
            loadingBtnConfirm,
            isLoadGetData,
            showModal,
            formDatas,
            formDataHs,
            parserValue,

            openp3bValidasiDialog,
            p3bValidasiModalRef,
            formDatasP3BValidasi,
            confirmP3bValidasiDialog,

            loadingBtnPengembalianPua,
            pengembalianPuaModalRef,
            openPengemalianPuaDialog,
            formDatasPengembalianPua,
            confirmPengembalianPua,

            //delete data
            loadingBtnHapusData,
            formDataHapusData,
            hapusDataRef,
            openHapusDataDialog,
            confirmHapusData,
            closeSistemInformation,
            isFinal
        }
    },
    components: {
        ValidationProvider,
        ValidationObserver,
        FormBiayaReadonly,
        FormFisikNotFoundReadonly,
        FormMobileTercatatReadonly,
        FormMobileTidakTercatatReadonly,
        ImageView
    },
    methods: {
        onModalClose() {
            this.$emit('closeDialog');
            this.formDataHs = {
                biaya_biaya: {},
                fisik_tidak_ditemukan: {},
                mobile: {
                    ganda_parent_detail_lokasi: {},
                    ganda_parent_detail_ruangan: {},
                }
            }; // set default
        },
        onModalConfirm() {
            this.$emit('confirmDialog');
            this.formDataHs = {
                biaya_biaya: {},
                fisik_tidak_ditemukan: {},
                mobile: {
                    ganda_parent_detail_lokasi: {},
                    ganda_parent_detail_ruangan: {},
                }
            }; // set default

        },
        badgeActionWf(action) {
            if (action == 'setuju') {
                return 'badge-light-success';
            } else {
                return 'badge-light-danger';
            }
        },
        badgeStatus(status) {
            if (status == 'dikirim') {
                return 'light-secondary';
            } else if (status == 'disetujui') {
                return 'light-success';
            } else if (status == 'dikembalikan') {
                return 'light-danger';
            }
        },
    },
    directives: {
        'b-tooltip': VBTooltip,
    },
    data() {
        return {
            required,
        }
    },
}
</script>